module.exports = __webpack_public_path__ + "media/sendMessage.765be77c.mp3";